import { combineReducers } from 'redux';
import {
  FETCH_PAYOUTS_REQUEST,
  FETCH_PAYOUTS_SUCCESS,
  FETCH_PAYOUTS_FAILURE,
} from '../../constants/ActionTypes';

// const mockData = [
//   {
//     _id: '60548708cc732530a452d734',
//     user: {
//       _id: '5f9aa1a9f9ff0e30bf37c6be',
//       name: 'John doe',
//       email: 'john@demo.com',
//       mobile: '9800000000',
//     },
//     invoice: {
//       _id: '605486a9dd4db9dcd86d7d96',
//       user: '5f9aa1a9f9ff0e30bf37c6be',
//       amount: 4400,
//       plan: 'plan-2',
//       status: 'paid',
//       referralProcessed: true,
//       updatedAt: '2021-03-19T11:12:08.592Z',
//     },
//     amount: 748,
//     description: 'Lorem',
//     status: 'pending',
//     source: {
//       invoice: '605486a9dd4db9dcd86d7d96',
//       amount: 4400,
//       award: {
//         type: 'revenue',
//         mode: 'percentage',
//         value: 17,
//       },
//     },
//     createdAt: '2021-03-19T11:12:08.573Z',
//     updatedAt: '2021-03-19T11:12:08.573Z',
//   },
//   {
//     _id: '605485c80046182e74c195c6',
//     user: {
//       _id: '5f9aa1a9f9ff0e30bf37c6be',
//       name: 'John doe',
//       email: 'john@demo.com',
//       mobile: '9800000000',
//     },
//     invoice: {
//       _id: '60532f506f74c6299550cf9f',
//       user: '5f9aa1a9f9ff0e30bf37c6be',
//       amount: 2200,
//       plan: 'plan-2',
//       status: 'paid',
//       referralProcessed: true,
//       updatedAt: '2021-03-19T11:06:48.197Z',
//     },
//     amount: 374,
//     description: 'Lorem',
//     status: 'pending',
//     source: {
//       invoice: '60532f506f74c6299550cf9f',
//       amount: 2200,
//       award: {
//         type: 'revenue',
//         mode: 'percentage',
//         value: 17,
//       },
//     },
//     createdAt: '2021-03-19T11:06:48.180Z',
//     updatedAt: '2021-03-19T11:06:48.180Z',
//   },
// ];

const list = (
  state = { data: {}, paging: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_PAYOUTS_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_PAYOUTS_SUCCESS:
      // mock data
      // action.data.data.data = mockData;

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
        paging: action.data.paging,
      };
    case FETCH_PAYOUTS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const payouts = combineReducers({
  list,
});

export default payouts;
